(function () {
    'use strict';
    var controllerId = 'attachAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'FileUploader', '_', 'tAttach', 'tSource', 'source', 'tAttachId', 'tSourceCode', 'tSourceId', 'sourceId', attachAdd]);

    function attachAdd($scope, datacontext, sectionMenu, $uibModalInstance, FileUploader, _, tAttach, tSource, source, tAttachId, tSourceCode, tSourceId, sourceId) {
        $scope.attach = {};
        $scope.tAttach = tAttach;
        $scope.tSource = tSource;
        $scope.source = source;
        $scope.MaxDim = '40 MB'; //40 MB
        $scope.maxKB = 40000;
        $scope.bTitleChanged = false;
        $scope.upload_URL = datacontext.upload_getURL();
        $scope.attach.uploaded = false;

        //console.log('tSource');
        //console.dir(tSource);

        //console.log('source');
        //console.dir(source);

        if (tSourceId) {
            $scope.tSourceId = tSourceId;
            $scope.attach.TSourceId = tSourceId;
            $scope.attach.TSourceName = $scope.tSource[0].Name;
        }

        if (tSourceCode) {
            //console.log('tSourceCode');
            //console.dir(tSourceCode);
            $scope.tSourceCode = tSourceCode;
            $scope.attach.TSourceName = $scope.tSource[0].Name;
            if (!source) {
                getListSource(tSourceCode);
            }
        }

        if (typeof $scope.attach.TSourceName == 'undefined') {
            $scope.attach.TSourceName = 'Riferimento';
        }

        if (sourceId) {
            $scope.sourceId = sourceId;
            $scope.attach.SourceId = sourceId;
        }

        if (tAttachId) {
            //console.log('tAttachId');
            $scope.tAttachId = tAttachId;
            $scope.attach.TAttachId = tAttachId;

            if ($scope.tAttach) {
                $scope.tAttach.forEach(function (item) {
                    if (item.Id == $scope.tAttachId)
                        $scope.attach.TAttach = item.Name;
                });
            }
            //console.info('attach.TAttach', $scope.attach.TAttach);
        }
        else {
            getTAttach(tSourceCode, sourceId); //se tAttach non � definito carico solo quelli non ancora presenti a sistema
        }

        

        $scope.ok = function (isValid) {
            if (isValid) {

                if ($scope.attach.TAttachId == 14) { //Documentazione integrativa
                    $scope.attach.iStato = 1; //Da verificare
                }


                var result = addItem($scope.attach);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.attach_add(item).then(function (data) {
                console.log('addItem');
                console.log(data);
                if (!data) return null;
                if (data == "400") return null;

                return data;
            });
        }

        $scope.TSourceChanged = function () {
            console.log('TSourceChanged');
            var tSourceId = $scope.attach.TSourceId;
            $scope.source = [];
            $scope.attach.SourceId = 0;
            $scope.tAttach = [];
            $scope.attach.TAttachId = 0;
            return datacontext.tSource_get(tSourceId).then(function (data) {
                $scope.tSourceCode = data.Code;
                getListSource(data.Code);
                return true;
            });
        };

        $scope.SourceChanged = function () {
            console.log('SourceChanged');
            $scope.tAttach = [];
            $scope.attach.TAttachId = 0;
            getTAttach($scope.tSourceCode, $scope.attach.SourceId);

            return false;
        };

        function getTAttach(tSourceCode, sourceId) {
            var onlyMissing = 1;
            //return datacontext.tAttach_getAllList(tSourceCode, 0, sourceId, onlyMissing).then(function (data) {
            return datacontext.tAttach_getAllModal(0, 0, tSourceCode, 0, sourceId, onlyMissing, '').then(function (data) {
                return $scope.tAttach = data;
            });
        }

        $scope.getMaxKB = function (tAttachId) {
            return $scope.tAttach.forEach(function (item) {
                if (item.Id == tAttachId) {
                    $scope.maxKB = item.MaxKB;
                }

                if ($scope.maxKB < 40000) {
                    if ($scope.maxKB >= 1024)
                        $scope.MaxDim = parseInt($scope.maxKB / 1024) + ' MB';
                    else if ($scope.maxKB < 1024)
                        $scope.MaxDim = parseInt($scope.maxKB) + ' KB';
                }

                return $scope.maxKB;
            });
        };

        function getListSource(tSourceCode) {
            console.log('getListSource');
            console.dir(tSourceCode);
            return datacontext.source_getAllList(tSourceCode).then(function (data) {
                return $scope.source = data;
            });
        }

        $scope.TitleChanged = function () {
            console.log('TitleChanged');
            $scope.bTitleChanged = true;
            return false;
        };

        $scope.removeFile = function (item) {
            $scope.attach.Path = '';
            $scope.attach.Name = '';
            $scope.attach.KB = 0;
            $('#inputFile').val("");

            $scope.attach.uploaded = false;
            return false;
        };



        // FILTERS
        var uploader = $scope.uploader = new FileUploader({
            url: $scope.upload_URL
        }
        );

        uploader.filters.push({
            name: 'customFilter',
            fn: function (item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        // CALLBACKS

        uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
            /*
        	console.info('onWhenAddingFileFailed', item, filter, options);
        	console.log('onWhenAddingFileFailed - end');
            */
        };
        uploader.onAfterAddingFile = function (fileItem) {
            /*
        	console.info('onAfterAddingFile', fileItem);
        	console.log('onAfterAddingFile - end');
        	console.dir(fileItem);
            */
        };
        uploader.onAfterAddingAll = function (addedFileItems) {
            /*
        	console.info('onAfterAddingAll', addedFileItems);
        	console.log('onAfterAddingAll - end');
            */
        };
        uploader.onBeforeUploadItem = function (item) {
            /*
            console.info('onBeforeUploadItem', item);
            console.log('onBeforeUploadItem');
            */
        };
        uploader.onProgressItem = function (fileItem, progress) {
            /*
            console.info('onProgressItem', fileItem, progress);
        	console.log('onProgressItem - end');
        	console.dir(progress);
            */
        };
        uploader.onProgressAll = function (progress) {
            /*
        	console.info('onProgressAll', progress);
        	console.log('onProgressAll - end');
            */
        };
        uploader.onSuccessItem = function (fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
            console.log('onSuccessItem - end');
            //console.dir(response);
            if (response != null && response.length > 0) {
                var data = response[0];
                $scope.attach.Path = data.PathServer;
                console.dir(data.PathServer);
                $scope.attach.Name = data.NameOrig;
                $scope.attach.KB = data.Length;
                $scope.attach.uploaded = true;
            }

        };
        uploader.onErrorItem = function (fileItem, response, status, headers) {
            /*
            console.info('onErrorItem', fileItem, response, status, headers);
        	console.log('onErrorItem - end');
            */
        };
        uploader.onCancelItem = function (fileItem, response, status, headers) {
            /*
        	console.info('onCancelItem', fileItem, response, status, headers);
        	console.log('onCancelItem - end');
            */
        };
        uploader.onCompleteItem = function (fileItem, response, status, headers) {
            /*
        	console.info('onCompleteItem', fileItem, response, status, headers);
        	console.log('onCompleteItem - end');
            */
        };
        uploader.onCompleteAll = function () {
            /*
        	console.info('onCompleteAll');
        	console.log('onCompleteAll - end');
            */
        };

        console.info('uploader', uploader);


    }
})();